import { Stack, Text, Box } from '@chakra-ui/react';

interface Props {
    title: string;
    description: string;
    children: React.ReactNode;
}

const Wrapper = ({ title, description, children }: Props) => {
    return (
        <Stack backgroundColor='white' border='1px solid' borderColor='gray.200' borderRadius='md' spacing='0'>
            <Stack padding='1.5rem'>
                <h3 className='text-2xl font-semibold leading-none tracking-tight'>{title}</h3>
                <Text className='text-sm text-[#71717a]'>{description}</Text>
            </Stack>

            <Box px='1.5rem' pb='1.5rem'>
                {children}
            </Box>
        </Stack>
    );
};

export default Wrapper;
